<template>
  <el-dialog
    title="温馨提示"
    :visible.sync="operateDialogVisible"
    width="500px"
    :append-to-body="true"
    :close-on-click-modal="false"
    :before-close="_operateDialogClose"
    custom-class="self-el-dialog login-limit-dialog"
    >
    <div class="el-dialog-self-body">
      <i class="iconfont iconwenxintishi"></i>
      <div class="dialog-content-line" v-if="isLogin">
        <span class="dialog-line">付费内容，购买学习卡后才能查看此内容哦</span>
        <br />
        <span class="dialog-line dialog-line-gray">
          已购买？
          <span class="is-color" @click="_operateDialogOk('bind')">立即绑卡</span>
        </span>
      </div>
      <div class="dialog-content-line" v-else>
        <span class="dialog-line">登录后，才能学习更多课程哦</span>
        <br />
        <span class="dialog-line dialog-line-gray">
          还未注册？
          <span class="is-color" @click="_operateDialogOk('register')">立即注册</span>
        </span>
      </div>
    </div>
    <div slot="footer" class="dialog-footer">
      <el-button
        v-if="isLogin"
        type="primary"
        size="small"
        @click="_operateDialogOk('purchase')"
      >立即购买</el-button>
      <el-button v-else type="primary" size="small" @click="_operateDialogOk('login')">登录</el-button>
      <span class="button-no-border" @click="_operateDialogClose">算了，先逛逛</span>
    </div>
  </el-dialog>
</template>
<script>
import { mapState } from "vuex";
export default {
  name: 'LimitDialog',
  props: {
    visible: {
      type: Boolean,
      default: false
    },
  },
  data() {
    return {
      operateDialogVisible: false
    }
  },
  computed: {
    ...mapState(["accountInfo", "isLogin"])
  },
  watch: {
    visible(val) {
      this.operateDialogVisible = val;
    }
  },
  methods: {
    _operateDialogOk(type) {
      this._operateDialogClose();
      if(type === 'bind') {
        this.$router.push('/binding-card');
      }else if(type === 'login') {
        this.$router.push('/home-page');
      }else if(type === 'register') {
        this.$router.push('/register');
      }else if(type === 'purchase') {
        let routeUrl = this.$router.resolve({
          path: "/purchase/product-details",
          query: {
            productId: 1
          }
        });
        window.open(routeUrl.href, '_blank');
      }
    },
    /**
     * 关闭操作弹框
     * **/
    _operateDialogClose() {
      this.operateDialogVisible = false;
      this.$emit('handleClick', false);
    },
  }
}
</script>
<style lang="less">

.login-limit-dialog {
  margin-top: 25vh !important;
  .el-dialog__body {
    // height: 254px;
    padding: 50px 30px 30px !important;
    .el-dialog-self-body {
      .iconwenxintishi {
        display: inline-block;
        font-size: 44px;
        color: #FF8181;
        vertical-align: top;
        margin-top: 7px;
        &.margin-top-2 {
          margin-top: 2px;
        }
      }
      .dialog-content-line {
        display: inline-block;
        padding-left: 24px;
        .dialog-line {
          line-height: 30px;
          font-size: 16px;
          &.dialog-line-gray {
            font-size: 14px;
            color: #868686;
            .is-color {
              font-size: 14px;
              color: #419EFF;
              cursor: pointer;
              &:hover {
                opacity: 0.7;
              }
            }
          }
        }
      }
    }
  }
  .el-dialog__footer {
    padding: 0 30px 20px;
    .dialog-footer {
      text-align: right;
      .el-button {
        width: 100px;
      }
      .button-no-border {
        margin-left: 30px;
      }
    }
  }
}
</style>